import { gql } from '../../../apollo/__generated__';

export const UPDATE_MILESTONE = gql(`
  mutation UpdateMilestone($updateMilestoneInput: UpdateMilestoneInput!) {
    updateMilestone(updateMilestoneInput: $updateMilestoneInput) {
      id
      name
      noAlcoholDiscount
      bedroomValue
      prices {
        day
        value
      }
      startAt
      endAt
    }
  }
`);
